<template>
	<div class="header-sidebar mb-4" slot="header" style="height: 500px">
		<h4 v-if="mode=='create'" class="pull-left">
			{{$t('chiqim.create')}}
		</h4>
		<h4 v-if="mode=='edit'" class="pull-left">
			{{$t('chiqim.edit')}}
		</h4>
		<!--<h4 class="pull-left" v-else>-->
		<!--{{ $t('promo-to-product.promo') }} - {{newPromo.name}}-->
		<!--</h4>-->
		<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
			class="fa fa-close"></i></b-button>
		<div class="clearfix"></div>
		<hr>
		<div class="row top">
			<b-col sm="3">
				<label class="lebeltop">
						<span class="redStar">

										</span>{{$t('expenses.date')}}</label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>

					<date-picker v-model="itemLocal.formalDate"
								 lang="ru"
								 placeholder="dd-mm-yyyy"
								 valueType="format"
								 format="DD-MM-YYYY"
					></date-picker>
				</b-form-group>
			</b-col>
			<b-col sm="3">
				<label class="lebeltop">
						<span class="redStar">

										</span>{{$t('expenses.month')}}</label>
				<b-form-group
					label-size="sm"
					label-for="refName"
					class="required"
				>

					<date-picker v-model="itemLocal.forWhatDate"
								 lang="ru"
								 type="month"
								 placeholder="yyyy-mm"
								 valueType="format"
								 format="MM-YYYY"
					></date-picker>
				</b-form-group>
			</b-col>

		</div>
		<div class="row">
			<div class="col-sm-3">
				<label class="lebeltop">{{$t('expenses.type')}}</label>
				<b-form-select v-model="itemLocal.typeExpensesId"
							   :plain="false"
							   :options="dropdowns.position.items"
							   size="sm"
							   label-for="typeExpensesName"
							   :required="true"
							   :text-field="'name'"
							   :value-field="'id'"
							   @reload="loadExpenses"
				>
					<template slot="first">
						<option :value="null" disabled>--
							{{$t('expenses.type')}}--
						</option>
					</template>
				</b-form-select>
			</div>
			<b-col sm="3">
				<label for="input-small">
								<span>
									{{$t('pos.sum')}}
								</span>
				</label>
				<b-input-group
					size="sm"
					class="mb-3"
				>
					<b-form-input
						:placeholder="$t('pos.sum')"
						v-model="itemLocal.price"
						type="text"
					>
					</b-form-input>
				</b-input-group>
			</b-col>
			<b-col sm="3">
				<label for="input-small">
								<span>
									{{$t('incomes.reason')}}
								</span>
				</label>
				<b-input-group
					size="sm"
					class="mb-3"
				>
					<b-form-input
						:placeholder="$t('incomes.reason')"
						v-model="itemLocal.reason"
						type="text"
					>
					</b-form-input>
				</b-input-group>
			</b-col>
		</div>
		<div class="row top mt-3 justify-content-end">
			<div class="col-2">
				<b-button variant="outline-danger" size="sm" block
						  @click="closeCreateExpenses">
					{{$t('actions.cancel')}}
				</b-button>
			</div>
			<div class="col-2">
				<b-button variant="outline-success" size="sm" block @click="saveExpenses">
					{{$t('actions.save')}}
				</b-button>
			</div>
		</div>
	</div>

</template>

<script>
import ReferencesService from "../../../services/references.sevice";
import {mapActions, mapState} from "vuex";

const itemInitial = {
		id: null,
		formalDate: '',
		forWhatDate: '',
		price: '',
		reason: '',
		typeExpensesId: null,


	};
	export default {
		name: "addExpenses",
		props: {
			mode: {
				type: String,
				default: "create"
			},
		},
		data() {

			return {
				itemLocal: {
					formalDate: '',
					forWhatDate: '',
					price: '',
					reason: '',
					typeExpensesId: null,
				},
				filter: {
					typeExpensesCode: null,
					formalDate: null,
					forWhatDate: null,
					price: null
				},
				dropdowns: {
					position: {
						items: [],
						value: null,
					}
				},
				search: {
					page: 1,
					limit: 20,

				}


			}
		},
		methods: {
			...mapActions('expenses', [
				'createExpenses', 'getAllExpensesStore', 'updateExpensesStore','searchFilter'
			]),
			cancel() {
				this.$emit('close', true);
			},
			closeCreateExpenses() {
				this.$emit('close', true);
			},
			async saveExpenses() {
				if (this.itemLocal.forWhatDate !== '' && this.itemLocal.formalDate !== '' && this.itemLocal.price !== '' && this.itemLocal.typeExpensesId !== null) {
					if (this.mode == 'create') {
						await this.createExpenses(this.itemLocal);
						this.$vs.notify({
							text: 'Добавить расход',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					} else {
						await this.updateExpensesStore(this.itemLocal);
						this.$vs.notify({
							text: 'Изменить расход',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});

					}
					await this.$emit('close', true);

				} else {

					this.$vs.notify({
						text: 'Заполните все обязательное поле',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});

				}
				let data = {}
				data.search = this.search;
				data.filter = this.filter;
				await this.searchFilter(data);

			},
			loadExpenses() {
				ReferencesService.getReferenceChildren(`expenses`).then(response => {
					this.dropdowns.position.items = response.data;

				})
			},
		},
		computed: {
			...mapState('expenses', [
				'itemLocalStore'
			]),
		},
		mounted() {
			if (this.mode == 'create') {
				this.itemLocal = Object.assign({}, itemInitial);
			} else {
				this.itemLocal = this.itemLocalStore;
			}
			this.loadExpenses();
		},

	}
</script>

<style scoped>

</style>
